<template>
<div>
<!-- <div class="theam-layout"> 
   <div class="theam-layout-event-content">
       <div class="theam-layout-event-content__old">
         <span class="theam-layout-event-content__old-value"><strike> {{ event.Event.Market.Option[priceboostSelection]['@odds'] }} </strike> </span>        
       </div>
          <div class="theam-layout-event-content__new">
          <span class="theam-layout-event-content__new-value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>            
       </div>
   </div>
   <div class="theam-layout-images">
     <div class="theam-layout-images-block">
        <img class="theam-layout-images-block-one" :src="teamShirt" alt=""  @error.once="handleImageError">
     </div>
   </div>
</div> -->

<div class="theam-layout"> 
   <div class="theam-layout-event-content">
       <div class="theam-layout-event-content__old">
         <span class="theam-layout-event-content__old-value"><strike> {{ event.Event.Market.Option[priceboostSelection]['@odds'] }} </strike> </span>        
       </div>
          <div class="theam-layout-event-content__new">
          <span class="theam-layout-event-content__new-value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>            
       </div>
   </div>
  <div class="theam-layout-images" v-if="!scContent.FieldValues.Parameters['jersey_img']">
     <div class="theam-layout-images-block">
        <img class="theam-layout-images-block-one" :src="teamShirt" alt=""  @error.once="handleImageError">
     </div>
   </div>
   </div>

	<div class="theam-content">
    <div>
	<div class="promo-header">
	     <header v-html="scContent.FieldValues.Parameters['title'] ">   </header>
</div>
		 <div>
		 <span class="sub-header" v-html="scContent.FieldValues.Parameters['copy_claim']" > </span>     
		 </div>
		 <br>
		 <div>
		         <a class="button button--primary" style="text-transform: capitalize;" :href="scContent.FieldValues.Parameters['link_cta']">Bet Now</a>
				 </div>
         <br>
	</div>
	</div>
    <div class="event__details" >
           <p style="color: white;"> {{ eventDate }} {{ event.Event['@name'] }} </p>
        </div>
</div>
  <!-- <div class="priceboost priceboost--single promo-container">
    <div class="jerseys">
      <div class="jersey-container">
        <img :src="teamShirt" alt="" class="jersey" @error.once="handleImageError">
      </div>
    </div>
    <div class="event-content">
      <div class="title">
        {{ scContent.FieldValues.Title }}
      </div>
      <div class="event">
        <div class="event__claim" v-html="scContent.FieldValues.Parameters['copy_claim']"></div>
      </div>
      <div class="event-odds">
        <div class="event-odds__was">
          <span class="event-odds__label">{{ scContent.FieldValues.Parameters['copy_was-label'] }}</span>
          <span class="event-odds__value">{{ event.Event.Market.Option[priceboostSelection]['@odds'] }}</span>
        </div>
        <a class="event-odds__now" :href="event.Event['@link']">
          <span class="event-odds__label">{{ scContent.FieldValues.Parameters['copy_now-label'] }}</span>
          <span class="event-odds__value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>
        </a>
      </div>
      <div class="event-text" v-html="scContent.FieldValues.Text"></div>
      <div
        v-if="!loggedin"
        class="event-cta"
      >
        <a class="button button--cta button--md" :href="scContent.FieldValues.Parameters['link_cta']">{{ scContent.FieldValues.Parameters['copy_cta'] }}</a>
      </div>
    </div>
  </div> -->
</template>
<script>
export default {
  props: [
    'scContent',
    'teamShirts',
    'event',
    'eventDate',
    'priceboostSelection',
    'loggedin'
  ],
  data() {
    return {
    };
  },
  computed: {
    teamShirt() {
      if (this.priceboostSelection == 0) {
        return this.teamShirts.home;
      } else {
        return this.teamShirts.away;
      }
    },
  },
  methods: {
    handleImageError(e) {
      e.target.src = this.teamShirts.fallback;
    },
  },
  mounted() {},
};
</script>
